<script lang="ts">
  import type {TextBlock, CurrentResponses} from '../types';
  import {getDisplayValue} from '../utils';
  import Markdown from '../Markdown.svelte';
  export let question: TextBlock;
  export let currentResponses: CurrentResponses;
  $: text = getDisplayValue<TextBlock>(currentResponses, question, 'text');
  $: label = getDisplayValue<TextBlock>(currentResponses, question, 'label');
</script>

<div class="mb-8">
  <Markdown text={`${label}`} shadowLineBreaks={true} />
  <div>
    <Markdown bind:text shadowLineBreaks={true} />
  </div>
</div>
